// 🔧 map_defaults.js
// ✅ Purpose: Creates default map settings for Seed Engine events
// ✅ Features:
// - Builds the same map fields managed by settings_map.js
// - Creates realistic event location markers
// - Uses the real settings/voting schema
// - Future-ready for industry-specific map templates
// - Fully block-commented for clarity and future devs

export const buildMapSettings = ({
  industryTemplate,
  eventResult,
} = {}) => {
  const industryLabel =
    industryTemplate?.label || "Car Show";

  const eventStart = eventResult?.eventDoc?.startDate || null;
  const eventEnd = eventResult?.eventDoc?.endDate || eventStart;
  const eventStartDate = eventStart?.toDate
    ? eventStart.toDate()
    : eventStart instanceof Date
    ? eventStart
    : null;
  const showWinnerResultsAt = eventStartDate
    ? [
        eventStartDate.getFullYear(),
        String(eventStartDate.getMonth() + 1).padStart(2, "0"),
        String(eventStartDate.getDate()).padStart(2, "0"),
      ].join("-") +
      `T${String(eventStartDate.getHours()).padStart(2, "0")}:${String(
        eventStartDate.getMinutes()
      ).padStart(2, "0")}`
    : "";

  return {
    // A bundled map keeps demo creation fast and deterministic while still
    // giving the seeded markers a real surface to render on.
    eventMap: "/demo-assets/default-event-map.svg",

    // Demo voting and entry windows mirror the event itself so every newly
    // created Experience is immediately usable without additional setup.
    publicEntryStart: eventStart,
    publicEntryEnd: eventEnd,
    votingStart: eventStart,
    votingEnd: eventEnd,
    votingOpen: true,
    bestInShowEnabled: true,
    showWinnerResultsAt,

    eventLocationMarkers: [
      {
        id: "seed-registration",
        title: "Registration Tent",
        note: `Check in here for the ${industryLabel.toLowerCase()} demo event.`,
        markerLabel: "R",
        mapMarkerType: "event_location",
        locationType: "registration",
        mapMarkerColor: "bg-primary text-white",
        mapMarkerX: 22,
        mapMarkerY: 34,
        createdAt: new Date().toISOString(),
      },

      {
        id: "seed-parking",
        title: "Main Parking",
        note: "Primary attendee parking area.",
        markerLabel: "P",
        mapMarkerType: "event_location",
        locationType: "parking",
        mapMarkerColor: "bg-success text-white",
        mapMarkerX: 12,
        mapMarkerY: 78,
        createdAt: new Date().toISOString(),
      },

      {
        id: "seed-awards",
        title: "Awards Stage",
        note: "Awards and winner announcements take place here.",
        markerLabel: "A",
        mapMarkerType: "event_location",
        locationType: "awards",
        mapMarkerColor: "bg-dark text-white",
        mapMarkerX: 72,
        mapMarkerY: 42,
        createdAt: new Date().toISOString(),
      },

      {
        id: "seed-first-aid",
        title: "First Aid",
        note: "Medical assistance and event support.",
        markerLabel: "+",
        mapMarkerType: "event_location",
        locationType: "first_aid",
        mapMarkerColor: "bg-danger text-white",
        mapMarkerX: 84,
        mapMarkerY: 62,
        createdAt: new Date().toISOString(),
      },

      {
        id: "seed-food",
        title: "Food Court",
        note: "Food vendors and refreshments.",
        markerLabel: "F",
        mapMarkerType: "event_location",
        locationType: "food",
        mapMarkerColor: "bg-secondary text-white",
        mapMarkerX: 56,
        mapMarkerY: 74,
        createdAt: new Date().toISOString(),
      },
    ],
  };
};
